var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55705 1.09001H9.89672L5.39172 14.4378C5.34541 14.575 5.25726 14.6942 5.13967 14.7786C5.02209 14.8631 4.88098 14.9085 4.73622 14.9085H1.35888C1.2492 14.9085 1.14109 14.8824 1.0435 14.8324C0.945908 14.7823 0.861638 14.7097 0.797662 14.6206C0.733686 14.5315 0.691842 14.4285 0.675592 14.32C0.659343 14.2116 0.669155 14.1008 0.704216 13.9968L4.90138 1.56068C4.94766 1.42346 5.03583 1.30422 5.15345 1.21976C5.27108 1.13529 5.41224 1.09002 5.55705 1.09001Z",
    fill: "url(#paint0_linear_1221_5476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8626 10.043H4.98096C4.91698 10.0429 4.85447 10.0621 4.80156 10.0981C4.74864 10.134 4.70779 10.1851 4.68432 10.2446C4.66085 10.3041 4.65584 10.3693 4.66996 10.4317C4.68408 10.4941 4.71666 10.5508 4.76346 10.5945L9.18546 14.7218C9.31421 14.8419 9.48373 14.9087 9.6598 14.9086H13.5565L11.8626 10.043Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55617 1.08985C5.40978 1.08929 5.26704 1.13555 5.14881 1.22188C5.03058 1.3082 4.94305 1.43007 4.899 1.56968L0.7085 13.9853C0.67108 14.0897 0.659332 14.2014 0.67425 14.3112C0.689168 14.421 0.730313 14.5256 0.794205 14.6162C0.858096 14.7067 0.942855 14.7805 1.04131 14.8314C1.13976 14.8823 1.24902 14.9086 1.35983 14.9083H4.82433C4.95337 14.8853 5.07397 14.8284 5.17382 14.7435C5.27367 14.6586 5.34919 14.5487 5.39267 14.425L6.22833 11.9622L9.21333 14.7463C9.33842 14.8498 9.49534 14.907 9.65767 14.9083H13.5398L11.8372 10.0427L6.87367 10.0438L9.9115 1.08985H5.55617Z",
    fill: "url(#paint1_linear_1221_5476)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1005 1.55984C11.0543 1.42285 10.9663 1.30381 10.8488 1.21949C10.7314 1.13517 10.5905 1.08983 10.4459 1.08984H5.60938C5.75395 1.08985 5.89488 1.13521 6.01232 1.21952C6.12976 1.30384 6.2178 1.42286 6.26404 1.55984L10.4614 13.9965C10.4965 14.1005 10.5063 14.2113 10.4901 14.3198C10.4738 14.4283 10.432 14.5313 10.368 14.6205C10.304 14.7096 10.2198 14.7822 10.1222 14.8323C10.0245 14.8824 9.91642 14.9085 9.80671 14.9085H14.6434C14.7531 14.9085 14.8612 14.8823 14.9588 14.8322C15.0563 14.7821 15.1406 14.7095 15.2046 14.6204C15.2685 14.5313 15.3103 14.4282 15.3266 14.3197C15.3428 14.2112 15.333 14.1004 15.2979 13.9965L11.1005 1.55984Z",
    fill: "url(#paint2_linear_1221_5476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1221_5476",
    x1: 7.13872,
    y1: 2.11401,
    x2: 2.63188,
    y2: 15.4283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1221_5476",
    x1: 8.54567,
    y1: 8.31868,
    x2: 7.50317,
    y2: 8.67118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1221_5476",
    x1: 7.97387,
    y1: 1.72551,
    x2: 12.921,
    y2: 14.9057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftDropdown);
export default __webpack_public_path__ + "static/media/microsoftDropdown.f620122d20608d9bba183a472bff24b5.svg";
export { ForwardRef as ReactComponent };